import styles from "./styles.module.scss";
import { Button } from "@radix-ui/themes";
import { EmptyState } from "../../assets/icons/emptyState";

export const EmptyStateComponent = ({
  title,
  description,
  cta = "Talk to us",
}: {
  title: string;
  description: string;
  cta?: string;
}) => {
  return (
    <div className={styles.emtpyStateContainer}>
      <EmptyState />
      <h3>{title}</h3>
      <p className="text-gray-600 text-lg">{description}</p>
      <div>
        <Button
          color="gray"
          variant="solid"
          highContrast
          size="1"
          onClick={() =>
            window.open("mailto:support@quackaihelp.zendesk.com", "_blank")
          }
        >
          {cta}
        </Button>
      </div>
    </div>
  );
};
